import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { getAllMatchesOddsCricketAPI } from "../service/cricket";
import {
  getAllMatchesOddsSoccerAPI,
  getAllMatchesOddsTennisAPI,
} from "../service/soccer&tennis";

export default function Sidebar() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [selectedGame, setSelectedGame] = React.useState(null);
  const [gameData, setGameData] = useState({
    cricket: [],
    tennis: [],
    soccer: [],
  });

  const getSoccerMatches = async () => {
    const { response, code } = await getAllMatchesOddsSoccerAPI();
    if (code == 200) {
      setGameData({
        ...gameData,
        soccer: response,
      });
      dispatch({
        type: "gameData/setSoccerGames",
        payload: response,
      });
    }
  };
  const getTennisMatches = async () => {
    const { response, code } = await getAllMatchesOddsTennisAPI();
    if (code == 200) {
      setGameData({
        ...gameData,
        tennis: response,
      });
      dispatch({
        type: "gameData/setTennisGames",
        payload: response,
      });
    }
  };
  const getCricketMatches = async () => {
    const { response, code } = await getAllMatchesOddsCricketAPI();
    if (code == 200) {
      setGameData({
        ...gameData,
        cricket: response,
      });
      dispatch({
        type: "gameData/setCricketGames",
        payload: response,
      });
    }
  };
  useEffect(() => {
    let interval;
    if (selectedGame == "cricket") {
      getCricketMatches();
      interval = setInterval(() => {
        getCricketMatches();
      }, 5000);
    } else if (selectedGame == "soccer") {
      getSoccerMatches();
      interval = setInterval(() => {
        getSoccerMatches();
      }, 5000);
    } else if (selectedGame == "tennis") {
      getTennisMatches();
      interval = setInterval(() => {
        getTennisMatches();
      }, 5000);
    } else {
      getSoccerMatches();
      getCricketMatches();
      getTennisMatches();
      interval = setInterval(() => {
        getSoccerMatches();
        getCricketMatches();
        getTennisMatches();
      }, 5000);
    }
    return () => {
      clearInterval(interval);
    };
  }, [selectedGame]);
  return (
    <div
      _ngcontent-ng-c1893399002=""
      className="sidebar showDesktop hideDekstop"
    >
      <app-side-bar _ngcontent-ng-c1893399002="" _nghost-ng-c1362099036="">
        <div _ngcontent-ng-c1362099036="" className="sidebar">
          <nav
            _ngcontent-ng-c1362099036=""
            className="sidebar-nav ps ps--active-y apply-scroll"
            style={{ width: "99.8%" }}
          >
            <div _ngcontent-ng-c1362099036="" className="top-head-sport">
              <ul _ngcontent-ng-c1362099036="" className="text-right mr-2">
                <li _ngcontent-ng-c1362099036="">
                  <a
                    onClick={() => {
                      setSelectedGame(null);
                    }}
                    _ngcontent-ng-c1362099036=""
                    className="path-back"
                  >
                    <i
                      _ngcontent-ng-c1362099036=""
                      aria-hidden="true"
                      className="fa fa-ellipsis-v"
                      style={{ fontSize: 14 }}
                    />
                  </a>
                </li>
                <li _ngcontent-ng-c1362099036="">
                  <a
                    _ngcontent-ng-c1362099036=""
                    style={{ position: "relative", top: "1.5px" }}
                  >
                    Sports
                  </a>
                </li>
              </ul>
            </div>
            <div _ngcontent-ng-c1362099036="" className="scrollNav">
              <ul _ngcontent-ng-c1362099036="" className="nav">
                {/**/}
                {selectedGame == null ? (
                  <div
                    _ngcontent-ng-c1362099036=""
                    className="sideW ng-star-inserted"
                  >
                    <li
                      _ngcontent-ng-c1362099036=""
                      className="nav-item nav-dropdown ng-star-inserted"
                    >
                      <a
                        _ngcontent-ng-c1362099036=""
                        onClick={() => setSelectedGame("cricket")}
                        className="nav-link nav-dropdown-toggle"
                      >
                        <span _ngcontent-ng-c1362099036="">Cricket</span>
                      </a>
                    </li>
                    <li
                      _ngcontent-ng-c1362099036=""
                      className="nav-item nav-dropdown ng-star-inserted"
                    >
                      <a
                        _ngcontent-ng-c1362099036=""
                        onClick={() => setSelectedGame("tennis")}
                        className="nav-link nav-dropdown-toggle"
                      >
                        <span _ngcontent-ng-c1362099036="">Tennis</span>
                      </a>
                    </li>
                    <li
                      _ngcontent-ng-c1362099036=""
                      className="nav-item nav-dropdown ng-star-inserted"
                    >
                      <a
                        _ngcontent-ng-c1362099036=""
                        className="nav-link nav-dropdown-toggle"
                      >
                        <span _ngcontent-ng-c1362099036="">Casino</span>
                      </a>
                    </li>
                    <li
                      _ngcontent-ng-c1362099036=""
                      className="nav-item nav-dropdown ng-star-inserted"
                    >
                      <a
                        _ngcontent-ng-c1362099036=""
                        onClick={() => setSelectedGame("soccer")}
                        className="nav-link nav-dropdown-toggle"
                      >
                        <span _ngcontent-ng-c1362099036="">Soccer</span>
                      </a>
                    </li>
                    <li
                      _ngcontent-ng-c1362099036=""
                      className="nav-item nav-dropdown ng-star-inserted"
                    >
                      <a
                        _ngcontent-ng-c1362099036=""
                        href="javascript:;"
                        className="nav-link nav-dropdown-toggle"
                      >
                        <span _ngcontent-ng-c1362099036="">Horse Racing</span>
                      </a>
                    </li>
                    <li
                      _ngcontent-ng-c1362099036=""
                      className="nav-item nav-dropdown ng-star-inserted"
                    >
                      <a
                        _ngcontent-ng-c1362099036=""
                        href="javascript:;"
                        className="nav-link nav-dropdown-toggle"
                      >
                        <span _ngcontent-ng-c1362099036="">
                          Greyhound Racing
                        </span>
                      </a>
                    </li>
                    <li
                      _ngcontent-ng-c1362099036=""
                      className="nav-item nav-dropdown ng-star-inserted"
                    >
                      <a
                        _ngcontent-ng-c1362099036=""
                        href="javascript:;"
                        className="nav-link nav-dropdown-toggle"
                      >
                        <span _ngcontent-ng-c1362099036="">Lottery</span>
                      </a>
                    </li>
                    {/**/}
                  </div>
                ) : (
                  <div
                    _ngcontent-ng-c1362099036=""
                    className="sideW ng-star-inserted"
                  >
                    {gameData[selectedGame]?.map((item) => (
                      <li
                        _ngcontent-ng-c1362099036=""
                        className="nav-item nav-dropdown ng-star-inserted"
                      >
                        <a
                          _ngcontent-ng-c1362099036=""
                          onClick={() =>
                            (window.location.href = `/game/${selectedGame}/${
                              item[selectedGame + "Id"]
                            }`)
                          }
                          className="nav-link nav-dropdown-toggle"
                        >
                          <span _ngcontent-ng-c1362099036="">
                            {item?.eventName}
                          </span>
                        </a>
                      </li>
                    ))}
                  </div>
                )}
                {/**/}
              </ul>
            </div>
            <div
              _ngcontent-ng-c1362099036=""
              className="ps__rail-y"
              style={{ top: 0, height: 403, right: 0 }}
            >
              <div
                _ngcontent-ng-c1362099036=""
                tabIndex={0}
                className="ps__thumb-y"
                style={{ top: 0, height: 379 }}
              />
            </div>
          </nav>
        </div>
      </app-side-bar>
    </div>
  );
}
